export default __webpack_public_path__ + "static/media/good.6cf3208a.svg";